"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emailAddressRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
function isValidEmailAddress(emailAddress) {
    //VSO: 1041: Separate out form field validation to a different package.
    return emailAddressRegex.test(emailAddress);
}
exports.default = isValidEmailAddress;
//# sourceMappingURL=isValidEmailAddress.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/utils/isValidEmailAddress.js
// module id = 2112
// module chunks = 2 3 4 45 90 108